<template><div><h1 id="aufgabepoststellen" tabindex="-1"><a class="header-anchor" href="#aufgabepoststellen"><span>Aufgabepoststellen</span></a></h1>
<p>Aufgabepoststellen — Definition der kundenspezifischen Aufgabepoststellen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die kundenspezifischen Aufgabepoststellen im System, die notwendig sind für die korrekte Bedienung von Bordereaux und <RouteLink to="/manual/administration/botenroutierung.html" title="6. Botenroutierung">Botenroutierung</RouteLink>.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Postdaten → Aufgabepoststellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Post</dt>
<dd>Kürzel für die Aufgabepoststelle, 3-stellig, alphanumerisch</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Aufgabepoststelle</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/botenroutierung.html" title="6. Botenroutierung">Botenroutierung</RouteLink></p>
</div></template>


